import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DsRadioModule } from '@frontend/ui/radio-button';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { LanguageSwitcherConfig } from './language-switcher.client-config';
import { LanguageSwitcherItem } from './language-switcher.models';

@Component({
    selector: 'vn-language-item',
    templateUrl: 'language-item.html',
    host: {},
    imports: [ImageComponent, IconCustomComponent, DsRadioModule],
})
export class LanguageItemComponent implements OnInit {
    config = inject(LanguageSwitcherConfig);
    private destroyRef = inject(DestroyRef);

    @Input() lang: LanguageSwitcherItem;
    @Input() displayRadioButton = true;

    version: number;

    ngOnInit() {
        this.config.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.version = this.config.version;
        });
    }
}
